module.exports = new __parcel__URL__("connecting.7204fd8c.svg").toString();